import { render, staticRenderFns } from "./simCardResource.vue?vue&type=template&id=6e7e75e6&scoped=true"
import script from "./simCardResource.vue?vue&type=script&lang=js"
export * from "./simCardResource.vue?vue&type=script&lang=js"
import style0 from "./simCardResource.vue?vue&type=style&index=0&id=6e7e75e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e75e6",
  null
  
)

export default component.exports